/**
 *
 * @param {string[]|ArrayBuffer[]|Blob} data
 * @param {string} filename
 * @param {string} [type]
 */

import { saveAs } from 'file-saver';
import axios from 'axios';
import { /* isTablet, */ isMobile } from '../utils/device';
import { isHuaweiBrowser, isSafari } from '../utils/browser-info';
import { windowActionFn } from '@/utils/utils';
import { store } from 'Store/store.index';

window.__saveAs__ = saveAs;

export function getDownloadEnv () {
    if (requireBlankWindow()) {
        return {
            windowOpen: windowActionFn(window, 'open', ['about:blank']),
            usingDataURI: isSafari && isMobile || isHuaweiBrowser
        }
    }
    return null;
}
export function downloadUrl(url, filename/* , safari */) {
    saveAs(url, filename);
}

export function download(data, filename, type/* , safari, isText */){
    if (isMobile && isSafari) {
        const regExp = new RegExp(/\sversion\/(.*?)\s/i);
        if (regExp.test(navigator.userAgent.toLowerCase()) && Number(RegExp.$1) < 13 && window.pdfui) {
            // TODO: send error
            return window.pdfui.alert('alert.browserNotSupportDownload');
        }
    }
    typeof type === 'undefined' && (type = 'application/octet-stream');
    const blob = data instanceof Blob ? data : new Blob(data, {type});

    saveAs(blob, filename);

}

export function convertToDataURL(blob, mimeType) {
    return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
            if(mimeType) {
                resolve(reader.result.replace(/^data:[^;]*;/, `data:${mimeType};`))
            }else {
                resolve(reader.result)
            }
        }
    });
}
function requireBlankWindow() {
    return isSafari;
}

export async function getFileBufferByUrl(url, callback,errorCallback) {
    if(url.search('http://localhost') != -1){
        downloadRangeUrl(url, callback,errorCallback)
    }else{
        console.log("打开文件")
        let headers = {}
        if (store.loginNewStore.IAMToken) {
            headers = {
                "Authorization": `Bearer ${store.loginNewStore.IAMToken}`
            }
        }
        console.log(headers)
        let result = await axios.get(url, {responseType: 'blob', headers: headers}).catch((err)=>{
            console.error("TCL: ConvertApis -> doGetRequest -> err", err)
            throw err;
        });
        //let result = response?response.data:null;
        if(result instanceof Blob){
            callback && callback(result);
            return result;
        }
        throw result;
    }


}
window.__Fns__ = window.__Fns__|| {}
window.__Fns__['getFileBufferByUrl'] = getFileBufferByUrl;

function downloadRange(url, start, end, i) {
    return new Promise((resolve, reject) => {
        //console.log("🚀 ~ file: download.api.js ~ line 90 ~ returnnewPromise ~ reject", reject)
        let formData = new FormData();
        formData.append('type', 'http');
        formData.append('uri', url);
        const req = new XMLHttpRequest();
        req.open("GET", url, true);
        req.setRequestHeader('range', `bytes=${start}-${end}`)
        req.responseType = "arraybuffer";
        req.onload = function () {
        resolve({
                i,
                buffer: req.response
            });
        };
        req.onerror = function (error) {
            console.log(error)
            reject('downloadRange error')
          };

        req.send(formData);
    })
}

function concatenate(resultConstructor, arrays) {
    let totalLength = 0;
    for (let arr of arrays) {
        totalLength += arr.length;
    }
    let result = new resultConstructor(totalLength);
    let offset = 0;
    for (let arr of arrays) {
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
export async function downloadRangeUrl(url, callback,errorCallback){
    const m = 1024 *1024*500;  // 分片的大小  500MB
    let headers = {}
    if (store.loginNewStore.IAMToken) {
        headers = {
            "Authorization": `Bearer ${store.loginNewStore.IAMToken}`
        }
    }
    axios({
        url,
        method: 'head',
        headers
    }).then(async(res) => {
        try {
            // 获取长度来进行分割块
            //console.time("开始下载");
            // Firefox上 获取到的content-length 没有 ','
            const contentLengthArr = res.headers['content-length'].split(',');
            const size = Number(contentLengthArr[contentLengthArr.length - 1]);
            const length = Math.ceil(size / m);
            // const arr = []
            const arrRes = []
            for (let i = 0; i < length; i++) {
                let start = i * m;
                let end = (i == (length - 1)) ?  size - 1  : (i + 1) * m - 1;
                let res = await downloadRange(url, start, end, i)
                arrRes.push(res)
                // arr.push(downloadRange(url, start, end, i))
            }
            const arrBufferList = arrRes.sort(item => item.i - item.i).map(item => new Uint8Array(item.buffer));
            const allBuffer = concatenate(Uint8Array, arrBufferList);
            const blob = new Blob([allBuffer], {type: "arraybuffer"});
            callback && callback(blob);
            // Promise.all(arr).then(res => { // 并行下载   exe暂不支持
            //     const arrBufferList = res.sort(item => item.i - item.i).map(item => new Uint8Array(item.buffer));
            //     const allBuffer = concatenate(Uint8Array, arrBufferList);
            //     const blob = new Blob([allBuffer], {type: "arraybuffer"});
            //     //const blobUrl = URL.createObjectURL(blob);
            //     //const aTag = document.createElement('a');
            //     //aTag.href = blobUrl;
            //     //aTag.click();
            //     //URL.revokeObjectURL(blob);
            //     //console.timeEnd("全部下载完成");
            //     callback && callback(blob);
            // })
        } catch (error) {
            errorCallback && errorCallback(error);
        }
    }).catch(function(err){
        console.log(err);
        errorCallback && errorCallback(err)
      })
}



